<template>
  <v-container fluid>
    <BaseTableFiltered
        ref="baseTableRef"
        :title="$t('BatchRun')"
        :subtractHeight="subtractHeight"
        :height="height"
        dto-model="BatchRunListQueryDTO"
        dto-save-list-model="BatchRunSaveListCommandDTO"
        store-name="PBatchRunTable"
        new-item-component="PBatchRunItem"
        new-item-pass="/PBatchRun/BatchRun/PBatchRunItem"
        :lang-dictionary="function(text) {return $t(text)}"
        fixed-header
        row-statuses="row_statuses"
        show-selected
        :single-select="singleSelect"
        :action-selected="actionSelected"
        :init-search-term="initSearchTerm"
        @choice="$emit('choice', $event)"
        @changeSearchTerm="$emit('changeSearchTerm', $event)"
        @item-selected="$emit('item-selected', $event)"
        :metadata="metadata"
        @click:row="$emit('click:row', $event)"
    >
      <template v-slot:item.year_week="{ item }">
        <router-link :to="{name:'PBatchRunItem', params: { itemUid: item.uid}}">
          <span v-if="!!item.year_week" class="d-flex justify-start">{{ item.year_week }}</span>
          <span v-else class="d-flex justify-start">****</span>
        </router-link>
      </template>
      <template v-slot:item.notion_id="{ item }">
        <BaseNotionLink :value="item.notion_id" small outlined></BaseNotionLink>
      </template>
      <template v-slot:item.customer_order__title="{ item }">
        <router-link :to="{name:'PCustomerOrderSoloItem', params: { itemUid: item.customer_order__uid}}">
          <span class="d-flex justify-start">{{ item.customer_order__title }}</span>
        </router-link>
      </template>
      <template v-slot:item.customer_order__notion_id="{ item }">
        <BaseNotionLink :value="item.customer_order__notion_id" small outlined></BaseNotionLink>
      </template>
      <template v-slot:item.status="{ item }">
        <BatchRunStatus :value="item.status" small></BatchRunStatus>
      </template>
      <template v-slot:item.target_finish_date="{ item }">
        <v-chip v-if="!!item.target_finish_date" small :color="item.target_finish_date_color">{{item.target_finish_date | moment("DD.MM.YY")}}</v-chip>
      </template>
      <template v-slot:item.tht_start_plan="{ item }">
        <v-chip v-if="!!item.tht_start_plan" small :color="item.tht_start_plan_color">{{item.tht_start_plan | moment("DD.MM.YY")}}</v-chip>
      </template>
      <template v-slot:item.remaining_task="{ item }">
        <v-chip v-for="task of item.remaining_task" outlined small>{{task}}</v-chip>
        {{''}}
      </template>
      <template v-slot:item.ma_list="{ item }">
        <v-chip v-for="user of item.ma_list" outlined small v-if="!!user">{{user}}</v-chip>
        {{''}}
      </template>
    </BaseTableFiltered>
    <v-dialog max-width="900" v-model="informationDialog">
      <v-card max-height="600" class="overflow-y-auto">
        {{ information }}
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import BaseImageCard from "@/components/Base/BaseImageCard";
import commonFunction from "@/commonFunction/commonFunction";
import BaseTableFiltered from "@/components/Base/BaseTableFieltered";
import BaseFilterGroupTable from "@/components/Base/BaseFilterGroupTable";
import BaseNotionLink from "@/components/Base/BaseNotionLink";
import BatchRunStatus from "@/components/PBatchRun/BatchRun/BatchRunStatus";

export default {
  name: 'PBatchRunTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: false},
    actionSelected: {default: false},
    initSearchTerm: {default: null},
    metadata: {default: null},
  },

  components: {
    BaseImageCard,
    BaseTableFiltered,
    BaseFilterGroupTable,
    BaseNotionLink,
    BatchRunStatus,
  },

  computed: {
    ...commonFunction.mapStoreFields([]),
  },

  methods: {
    onNotion(notion_uid) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + notion_uid.replace(/-/g, ''), '_blank')
    },
    exportAction(instance) {
      let selected_uid_list = []
      instance.selectedItemList.forEach(row => selected_uid_list.push(row.uid))
      let dto_search = {
        current_uid: null,
        selected_uid_list: selected_uid_list,
      }
      instance.fetchAction({dto: dto_search, dto_action_model: this.dto_export_model})
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      informationDialog: false,
      information: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>


<i18n src="@/components/PBatchRun/locales.json">
</i18n>
